import request from 'superagent';
import _random from 'lodash/random';
import { STRINGS } from 'config';
import { parseParams, stringifyParams } from 'common/url';
import { restartSession } from './session';

const login = STRINGS.LOGIN_REDUCER;

export const updateDevLogin = devLogin => ({ type: login.UPDATE_DEV_LOGIN, payload: devLogin });

export const goToNHSStubLogin = () => async dispatch => {
  await dispatch({ type: login.REDIRECT_TO_NHS_STUB_LOGIN });
  request
    .post('https://stub.signin.nhs.uk/authorize')
    .type('form')
    .send({
      response_type: 'code',
      client_id: '832a7164-93f7-4f23-9c77-4a2205227fab',
      client_type: 'confidential',
      state: `${window.location.href}`,
      nonce: 'noncevalue',
      scope: 'openid profile email phone gp_registration_details profile_extended',
      redirect_uri: 'https://assets.nhs-g3-test.webgp.com/',
      vtr: '["P9.Cd.Cp", "P9.Ck"]',
      login_hint: '9990134243',
      submission_type: 'POST',
    })
    .then(response => {
      // NHS stub login is a test case. Disabling eslint rule
      // eslint-disable-next-line no-console
      console.log(response);
    })
    .catch(error => {
      // NHS stub login is a test case. Disabling eslint rule
      // eslint-disable-next-line no-console
      console.log(error);
    });
};

export const submitDevLogin = devDetails => async (dispatch, getState) => {
  await dispatch({ type: login.SUBMIT_DEV_LOGIN });
  const { origin, pathname, hash, search, href } = window.location;
  const { TEST_CODE } = getState().loginReducer;
  const { codeName, twmid } = parseParams(search);
  const data = encodeURI(JSON.stringify(JSON.parse(devDetails)));
  const query = stringifyParams({ codeName, twmid, data, code: TEST_CODE });
  const loginUrl = `${origin}${pathname}${query}`;
  if (`${loginUrl}${hash}` === href) {
    const changeUrl = `&change=${_random(100)}`;
    window.location.assign(`${loginUrl}${changeUrl}${hash}`);
  } else {
    window.location.assign(`${loginUrl}${hash}`);
  }
};

export const updateLoginStatus = loginStatus => ({ type: login.UPDATE_LOGIN_STATUS, payload: loginStatus });

export const setTestCode = testCode => ({ type: login.SET_TEST_CODE, payload: testCode });

export const logOut = () => dispatch => {
  dispatch(restartSession());
  dispatch({ type: login.LOGOUT_USER });
};
